import React, { useEffect, useState } from "react";
import { DailyIcon } from "@/features/daily/components/DailyIcon";

type Props = {
    value: string;
    onSearch: (term: string) => void;
    /** What the server said about the last term, in words the operator can act on. */
    error: string | null;
};

/**
 * D99: the operator searches by OPERATION ID or by ACCOUNT EMAIL. Enmienda C14 /
 * SC-025 still hold — the term is held in component state and travels to the server
 * in a request header, never in the URL — so a link pasted into a ticket carries
 * nothing identifying and no proxy log ever sees what was typed.
 */
export const SearchBox: React.FC<Props> = ({ value, onSearch, error }) => {
    const [draft, setDraft] = useState(value);

    // A term applied from elsewhere (the "filter by this email" button) shows up here.
    useEffect(() => { setDraft(value); }, [value]);

    return (
        <form
            className="daily-search-row"
            role="search"
            aria-label="Buscar operaciones"
            onSubmit={(event) => {
                event.preventDefault();
                onSearch(draft.trim());
            }}
        >
            <span className="daily-search__label">
                <span className="daily-search__field">
                    <DailyIcon name="search" />
                    <label className="daily-visually-hidden" htmlFor="daily-search-term">Operación o correo electrónico</label>
                    <input
                        id="daily-search-term"
                        className="daily-search__input"
                        type="text"
                        inputMode="email"
                        value={draft}
                        autoComplete="off"
                        spellCheck={false}
                        placeholder="Buscar por id de operación o correo…"
                        aria-describedby="daily-search-hint"
                        onChange={(event) => setDraft(event.target.value)}
                    />
                    {draft === "" && value === "" ? (
                        <kbd id="daily-search-hint" className="daily-kbd">Enter</kbd>
                    ) : (
                        <>
                            <span id="daily-search-hint" className="daily-visually-hidden">Pulsa Enter para buscar</span>
                            <button
                                type="button"
                                className="daily-search__clear"
                                aria-label="Limpiar búsqueda"
                                onClick={() => {
                                    setDraft("");
                                    onSearch("");
                                }}
                            >
                                <DailyIcon name="close" />
                            </button>
                        </>
                    )}
                    <button type="submit" className="daily-search__submit" aria-label="Buscar">
                        <DailyIcon name="arrow_forward" />
                    </button>
                </span>
            </span>
            {error === null ? null : <p className="daily-search__error" role="alert">{error}</p>}
        </form>
    );
};
